import { Component, inject, OnInit } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { PasswordRecovery } from "@shared/model/user.model";
import { SnackbarService } from "@shared/services/snackbar.service";
import { UserApiService } from "@shared/services/users/userApi.service";
import { ClickarUtilsService } from "@shared/services/utils/clickar-utils.service";

@Component({
	selector: "app-password-recovery",
	templateUrl: "./password-recovery.component.html",
	styleUrl: "./password-recovery.component.scss",
	standalone: false
})
export class PasswordRecoveryComponent implements OnInit {
	userService = inject(UserApiService);
	utils = inject(ClickarUtilsService);

	private snackBarService = inject(SnackbarService);
	passwordRecovery: PasswordRecovery = new PasswordRecovery();
	passwordRecoveryForm: UntypedFormGroup = new UntypedFormGroup({
		username: new UntypedFormControl(""),
		email: new UntypedFormControl("")
	});
	selectedMode: any;

	ngOnInit() {
		// console.log(this.passwordRecoveryForm);
		this.passwordRecoveryForm.controls.username.setValidators(Validators.minLength(6));
		this.passwordRecoveryForm.controls.email.setValidators(Validators.email);
	}

	isInValid = () =>
		this.utils.isEmpty(this.passwordRecoveryForm.controls.username.value) &&
		this.utils.isEmpty(this.passwordRecoveryForm.controls.email.value);

	onSubmit() {
		if (!this.passwordRecoveryForm.invalid) {
			this.userService
				.passwordRecoveryUsingPOST(this.passwordRecoveryForm.getRawValue())
				.subscribe(() => {
					this.snackBarService.show({
						titlePlaceholder: "success.forgotPassword.msg"/* ,
						messagePlaceholder: "dialog.success.title" */
					});
				});
		}
	}

	changeEmail() {
		if (this.utils.isEmpty(this.passwordRecoveryForm.controls.email.value)) {
			this.passwordRecoveryForm.controls.email.setValidators(null);
			this.passwordRecoveryForm.controls.username.setValidators(Validators.minLength(6));
		} else {
			this.passwordRecoveryForm.controls.email.setValidators(Validators.email);
			this.passwordRecoveryForm.controls.username.setValidators(null);
			this.passwordRecoveryForm.controls.username.setErrors(null);
		}
		this.passwordRecoveryForm.updateValueAndValidity();
	}

	changeUsername() {
		// console.log(this.passwordRecoveryForm);
		if (
			this.utils.isEmpty(this.passwordRecoveryForm.controls.username.value)
		) {
			this.passwordRecoveryForm.controls.username.setValidators(null);
			this.passwordRecoveryForm.controls.email.setValidators(Validators.email);
		} else {
			this.passwordRecoveryForm.controls.email.setValidators(null);
			this.passwordRecoveryForm.controls.email.setErrors(null);
			this.passwordRecoveryForm.controls.username.setValidators(Validators.minLength(6));
		}
		this.passwordRecoveryForm.updateValueAndValidity();
	}
}